import HttpService from "./http.service";

class AuthService {
  login = async (payload) => {
    const loginEndpoint = "auth/login";
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = "register";
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = "auth/logout";
    const payload = {
      refresh_token: localStorage.getItem("refToken"),
    };
    return await HttpService.post(logoutEndpoint, payload);
  };

  forgotPassword = async (payload) => {
    const forgotPassword = "password-forgot";
    return await HttpService.post(forgotPassword, payload);
  };

  resetPassword = async (credentials) => {
    const resetPassword = "password-reset";
    return await HttpService.post(resetPassword, credentials);
  };

  getUserPermissions = async (id) => {
    // const endpoint = `permissions?fields=*&filter[policy][_eq]=${id}`;
    // const endpoint = `policies?fields=permissions.*&filter[roles].[role][_eq]=${id}`;
    const endpoint = `policies?fields=permissions.*&filter[users][user][_eq]=${id}`;
    return await HttpService.get(endpoint);
  };

  getProfile = async () => {
    const getProfile = "users/me?fields=*,role.name,role.id";
    return await HttpService.get(getProfile);
  };

  updateProfile = async (newInfo) => {
    const updateProfile = "users/me";
    return await HttpService.patch(updateProfile, newInfo);
  };
}

export default new AuthService();
